/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateJobOfferRequest,
  HireJobOffersListParams,
  StafferJobOffer,
  StafferJobOffersListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHireJobOffersListUrl = (params?: HireJobOffersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/hire/job-offers/?${stringifiedParams}` : `/api/hire/job-offers/`
}

/**
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 */
export const hireJobOffersList = async (params?: HireJobOffersListParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer[]> => {

  return customFetch<StafferJobOffer[]>(getHireJobOffersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobOffersListQueryKey = (params?: HireJobOffersListParams,) => {
    return [
    `/api/hire/job-offers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getHireJobOffersListQueryOptions = <TData = Awaited<ReturnType<typeof hireJobOffersList>>, TError = void>(params?: HireJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobOffersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobOffersList>>> = ({ signal }) => hireJobOffersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobOffersListQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobOffersList>>>
export type HireJobOffersListQueryError = void


export function useHireJobOffersList<TData = Awaited<ReturnType<typeof hireJobOffersList>>, TError = void>(
 params: undefined |  HireJobOffersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobOffersList>>,
          TError,
          Awaited<ReturnType<typeof hireJobOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobOffersList<TData = Awaited<ReturnType<typeof hireJobOffersList>>, TError = void>(
 params?: HireJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobOffersList>>,
          TError,
          Awaited<ReturnType<typeof hireJobOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobOffersList<TData = Awaited<ReturnType<typeof hireJobOffersList>>, TError = void>(
 params?: HireJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobOffersList<TData = Awaited<ReturnType<typeof hireJobOffersList>>, TError = void>(
 params?: HireJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobOffersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobOffersCreateUrl = () => {




  return `/api/hire/job-offers/`
}

/**
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 */
export const hireJobOffersCreate = async (createJobOfferRequest: CreateJobOfferRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferJobOffer>(getHireJobOffersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createJobOfferRequest)
  }
);}





export const getHireJobOffersCreateMutationKey = () => ['hireJobOffersCreate'] as const;

export const getHireJobOffersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersCreate>>, TError,HireJobOffersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersCreate>>, TError,HireJobOffersCreateMutationVariables, TContext> => {

const mutationKey = getHireJobOffersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobOffersCreate>>, HireJobOffersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hireJobOffersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobOffersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobOffersCreate>>>
    export type HireJobOffersCreateMutationBody = CreateJobOfferRequest
    export type HireJobOffersCreateMutationError = void
    export type HireJobOffersCreateMutationVariables = {data: CreateJobOfferRequest}

    export const useHireJobOffersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersCreate>>, TError,HireJobOffersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobOffersCreate>>,
        TError,
        HireJobOffersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobOffersCreateMutationOptions(options), queryClient);
    }
    export const getHireJobOffersRetrieveUrl = (id: string,) => {




  return `/api/hire/job-offers/${id}/`
}

/**
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 */
export const hireJobOffersRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer> => {

  return customFetch<StafferJobOffer>(getHireJobOffersRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHireJobOffersRetrieveQueryKey = (id: string,) => {
    return [
    `/api/hire/job-offers/${id}/`
    ] as const;
    }


export const getHireJobOffersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHireJobOffersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hireJobOffersRetrieve>>> = ({ signal }) => hireJobOffersRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HireJobOffersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hireJobOffersRetrieve>>>
export type HireJobOffersRetrieveQueryError = void


export function useHireJobOffersRetrieve<TData = Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobOffersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobOffersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobOffersRetrieve<TData = Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hireJobOffersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof hireJobOffersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHireJobOffersRetrieve<TData = Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHireJobOffersRetrieve<TData = Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hireJobOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHireJobOffersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getHireJobOffersDestroyUrl = (id: string,) => {




  return `/api/hire/job-offers/${id}/`
}

/**
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 */
export const hireJobOffersDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getHireJobOffersDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getHireJobOffersDestroyMutationKey = () => ['hireJobOffersDestroy'] as const;

export const getHireJobOffersDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersDestroy>>, TError,HireJobOffersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersDestroy>>, TError,HireJobOffersDestroyMutationVariables, TContext> => {

const mutationKey = getHireJobOffersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hireJobOffersDestroy>>, HireJobOffersDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  hireJobOffersDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HireJobOffersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof hireJobOffersDestroy>>>

    export type HireJobOffersDestroyMutationError = void
    export type HireJobOffersDestroyMutationVariables = {id: string}

    export const useHireJobOffersDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hireJobOffersDestroy>>, TError,HireJobOffersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hireJobOffersDestroy>>,
        TError,
        HireJobOffersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getHireJobOffersDestroyMutationOptions(options), queryClient);
    }
    export const getStafferJobOffersListUrl = (params?: StafferJobOffersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/staffer/job-offers/?${stringifiedParams}` : `/api/staffer/job-offers/`
}

/**
 * Deprecated — use /api/hire/job-offers/ instead. Behaviour is identical.
 *
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 * @deprecated
 */
export const stafferJobOffersList = async (params?: StafferJobOffersListParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer[]> => {

  return customFetch<StafferJobOffer[]>(getStafferJobOffersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferJobOffersListQueryKey = (params?: StafferJobOffersListParams,) => {
    return [
    `/api/staffer/job-offers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getStafferJobOffersListQueryOptions = <TData = Awaited<ReturnType<typeof stafferJobOffersList>>, TError = void>(params?: StafferJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferJobOffersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferJobOffersList>>> = ({ signal }) => stafferJobOffersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferJobOffersListQueryResult = NonNullable<Awaited<ReturnType<typeof stafferJobOffersList>>>
export type StafferJobOffersListQueryError = void


export function useStafferJobOffersList<TData = Awaited<ReturnType<typeof stafferJobOffersList>>, TError = void>(
 params: undefined |  StafferJobOffersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferJobOffersList>>,
          TError,
          Awaited<ReturnType<typeof stafferJobOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferJobOffersList<TData = Awaited<ReturnType<typeof stafferJobOffersList>>, TError = void>(
 params?: StafferJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferJobOffersList>>,
          TError,
          Awaited<ReturnType<typeof stafferJobOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferJobOffersList<TData = Awaited<ReturnType<typeof stafferJobOffersList>>, TError = void>(
 params?: StafferJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useStafferJobOffersList<TData = Awaited<ReturnType<typeof stafferJobOffersList>>, TError = void>(
 params?: StafferJobOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferJobOffersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferJobOffersCreateUrl = () => {




  return `/api/staffer/job-offers/`
}

/**
 * Deprecated — use /api/hire/job-offers/ instead. Behaviour is identical.
 *
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 * @deprecated
 */
export const stafferJobOffersCreate = async (createJobOfferRequest: CreateJobOfferRequest, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StafferJobOffer>(getStafferJobOffersCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createJobOfferRequest)
  }
);}





export const getStafferJobOffersCreateMutationKey = () => ['stafferJobOffersCreate'] as const;

export const getStafferJobOffersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferJobOffersCreate>>, TError,StafferJobOffersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferJobOffersCreate>>, TError,StafferJobOffersCreateMutationVariables, TContext> => {

const mutationKey = getStafferJobOffersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferJobOffersCreate>>, StafferJobOffersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stafferJobOffersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferJobOffersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof stafferJobOffersCreate>>>
    export type StafferJobOffersCreateMutationBody = CreateJobOfferRequest
    export type StafferJobOffersCreateMutationError = void
    export type StafferJobOffersCreateMutationVariables = {data: CreateJobOfferRequest}

    /**
 * @deprecated
 */
export const useStafferJobOffersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferJobOffersCreate>>, TError,StafferJobOffersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferJobOffersCreate>>,
        TError,
        StafferJobOffersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getStafferJobOffersCreateMutationOptions(options), queryClient);
    }
    export const getStafferJobOffersRetrieveUrl = (id: string,) => {




  return `/api/staffer/job-offers/${id}/`
}

/**
 * Deprecated — use /api/hire/job-offers/ instead. Behaviour is identical.
 *
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 * @deprecated
 */
export const stafferJobOffersRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<StafferJobOffer> => {

  return customFetch<StafferJobOffer>(getStafferJobOffersRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStafferJobOffersRetrieveQueryKey = (id: string,) => {
    return [
    `/api/staffer/job-offers/${id}/`
    ] as const;
    }


export const getStafferJobOffersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStafferJobOffersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>> = ({ signal }) => stafferJobOffersRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StafferJobOffersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>>
export type StafferJobOffersRetrieveQueryError = void


export function useStafferJobOffersRetrieve<TData = Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferJobOffersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferJobOffersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferJobOffersRetrieve<TData = Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stafferJobOffersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof stafferJobOffersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStafferJobOffersRetrieve<TData = Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useStafferJobOffersRetrieve<TData = Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stafferJobOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStafferJobOffersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStafferJobOffersDestroyUrl = (id: string,) => {




  return `/api/staffer/job-offers/${id}/`
}

/**
 * Deprecated — use /api/hire/job-offers/ instead. Behaviour is identical.
 *
 * Staffer endpoint for managing job offers.
 * - GET /hire/job-offers/ - List offers at managed locations
 * - GET /hire/job-offers/{id}/ - View offer details
 * - POST /hire/job-offers/ - Create an offer, either for a ``job_candidate`` already in the pipeline or
 *   for a ``pro_id`` + ``job_posting_id`` with no pipeline row yet (replaced
 *   /staffer/direct-job-offers/, removed in CORE-6792)
 * - DELETE /hire/job-offers/{id}/ - Withdraw offer
 * @deprecated
 */
export const stafferJobOffersDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getStafferJobOffersDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getStafferJobOffersDestroyMutationKey = () => ['stafferJobOffersDestroy'] as const;

export const getStafferJobOffersDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferJobOffersDestroy>>, TError,StafferJobOffersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stafferJobOffersDestroy>>, TError,StafferJobOffersDestroyMutationVariables, TContext> => {

const mutationKey = getStafferJobOffersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stafferJobOffersDestroy>>, StafferJobOffersDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  stafferJobOffersDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StafferJobOffersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof stafferJobOffersDestroy>>>

    export type StafferJobOffersDestroyMutationError = void
    export type StafferJobOffersDestroyMutationVariables = {id: string}

    /**
 * @deprecated
 */
export const useStafferJobOffersDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stafferJobOffersDestroy>>, TError,StafferJobOffersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stafferJobOffersDestroy>>,
        TError,
        StafferJobOffersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getStafferJobOffersDestroyMutationOptions(options), queryClient);
    }
